<template>
  <v-row
    no-gutters
    data-component-id="reprise-planner-layout"
    class="mx-0 mb-0"
    style="min-height: 314px;"
  >
    <v-col
      cols="3"
      class="
        d-flex flex-column justify-space-between
        pt-3 px-0 pb-2
      "
      style="flex: 0 0 376px; min-width: 376px;"
    >
      <slot name="left-section" />
    </v-col>

    <v-col
      data-component-id="planner-reprise"
      class="
        customScroll overflow-x-auto
        gap-4 d-flex
        pt-3 px-0 pb-2 pl-2 pr-4 border-left
      "
      style="--_scrollbar-height: 6px; --_border-left-color: var(--v-lightGray-darken1); --_border-left-width: 1px;"
      @scroll="syncRepriseScroll($event.target)"
    >
      <slot name="right-section" />
    </v-col>
  </v-row>
</template>

<script>
import { syncRepriseScroll } from '@/helpers/utils';

export default {
  name: 'ReprisePlannerLayout',
  setup () {
    return { syncRepriseScroll };
  }
};
</script>

<style>
[data-component-id="reprise-planner-layout"] {
  .v-input--selection-controls__input {
    margin-right: 0;
  }
}
</style>